<template>
    <div class="payment">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-11 col-xl-10">
                <div class="card shadow-sm">
                    <div class="card-body pt-5 px-5">
                        <h2 class="d-flex align-items-center">
                            <span>Paga las siguientes cuotas</span>
                        </h2>
                    </div>
                    <div class="mb-4 px-5">
                        <CardPaymentInQuotas :meta="meta" :feePayments="feePayments"
                            @selectFeePayments="selectFeePayments" :transactionId="ticketId" v-if="feePayments" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../api'
import ls from '../ls';

export default{
    name: 'Payment',
    data() {
        return {
            // feePayments: {},
        }
    },
    computed: {
        meta() {
            return this.$store.getters.cartEventsMeta;
        },
        feePayments(){
            return this.$store.getters.getFeePayments;
        },
        userFeePayment(){
            return this.$store.state.feePayments.user;
        },
        eventId(){
            return this.$store.state.feePayments.eventId;
        },
        ticketId(){
            return this.$route.params.ticketId;
        }
    },
    methods:{
        async getFeePayment(){
            this.setUserAndEventId();
            try {
              const res = await api.getFeePayment(this.ticketId);
            //   await this.$store.dispatch('changeIsCreateFeePayment');
              await this.$store.dispatch('setFeePayments', res.data);
            } catch (error) {
                console.log(error);
            }
        },
        selectFeePayments(value){
            if (value.length) {
                let feePayments = [];
                value.forEach(element => {
                    const obj = {
                        amount: element.amount,
                        order: element.order,
                    }
                    feePayments.push(obj)
                });

                if (value.length !== this.feePayments.feePayments.length) {
                    this.$store.dispatch('updateFeePayments', feePayments);
                } else {
                    this.$store.dispatch('updateFeePayments', []);
                }
                
            } else {
                this.$store.dispatch('updateFeePayments', []);
            }
        },
        async getTransaction(){
            const data = {
                type: 'transaction',
                value: this.ticketId
            }
            try {
                await api.getTransactionByParams(this.eventId, data)
            } catch (error) {
                console.log(error);
            }
        },
        setUserAndEventId(){
            if (Object.entries(this.userFeePayment).length === 0 && !this.eventId) {
                const fpUser = ls.getItem('fp-user');
                const dataSessionFeePayment = JSON.parse(fpUser);
                this.$store.dispatch('setEventId', dataSessionFeePayment.eventId);
                this.$store.dispatch('setUserFeePayment', dataSessionFeePayment.user);
            }
        }

    },
    mounted(){
        this.getFeePayment();
    }
}
</script>
<style lang="scss" scoped>
.payment {
    margin: 2rem 0 !important;
}
</style>